import { useCopies } from "shared/hooks/useCopies";
import { BuyBulkTicketService } from "../../types";
import BulkTicketQuantityForm from "./bulkTicketQuantityForm";
import BulkQuantityPriceBreakUpMap from "../../../../../../../../shared/components/bulkQuantityPriceBreakUpMap";
import BulkTicketsOrMeetingsPurchaseHistory from "apps/myExperience/components/bulkTicketsOrMeetingsPurchaseHistory";
import { useBulkTicketQuantityService } from "./service";
import React from "react";

export default function BulkTicketQuantity(props: { service: BuyBulkTicketService; ticketFormId: string }) {
  const copies = useCopies();
  const service = useBulkTicketQuantityService(props.ticketFormId);

  return (
    <React.Fragment>
      <div className="buyInventory_cardWrapper">
        <BulkQuantityPriceBreakUpMap
          applicableRates={service.applicableRates}
          perQuantityDisplayText={copies.get("price.per.ticket")}
          labelDisplayText={copies.get("buy.bulk.ticket.pricing.cards.title")}
          infoLabel={copies.get("buy.bulk.ticket.pricing.card.infoLabel")}
        />
        <BulkTicketQuantityForm
          ticketFormId={props.ticketFormId}
          applicableRates={service.applicableRates}
          selectedQuantity={props.service.selectedQuantity}
          initPurchaseHandler={props.service.initPurchaseHandler}
          pendingPO={props.service.state.purchaseOrder}
        />
      </div>
      <BulkTicketsOrMeetingsPurchaseHistory
        purchaseHistory={props.service.bulkTicketPurchaseHistory}
        originatingEntityId={props.ticketFormId}
      />
    </React.Fragment>
  );
}
